import React from "react";
import { useLocation } from "react-router-dom";
import cx from "classnames";

import { IconComponent } from "types/Icon";
import BadgeNext from "ds/components/BadgeNext";
import Box from "ds/components/Box";
import { SidebarNavigationItemRule } from "types/Navigation";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import Icon from "ds/components/Icon";

import { checkIsActive } from "./helpers";
import MenuItemText from "./MenuItemText";
import styles from "./styles.module.css";

type MenuItemProps = {
  ariaLabel: string;
  id?: string;
  to?: string;
  icon: IconComponent;
  rule?: SidebarNavigationItemRule;
  children?: React.ReactNode;
  className?: string;
  beta?: boolean;
};

const MenuItemDropdown = function ({
  id,
  children,
  to,
  icon,
  rule,
  className,
  ariaLabel,
  beta,
}: MenuItemProps) {
  const location = useLocation();

  const isActive = checkIsActive(location.pathname, rule);

  return (
    <DropdownMenuItem
      key={to}
      id={id}
      href={to}
      tooltipDisableAriaLabel
      className={cx(styles.menuItem, className)}
      active={isActive}
      aria-label={ariaLabel}
      activeClassName={styles.menuItemActive}
    >
      <Icon src={icon} size="large" noShrink />
      {beta ? (
        <Box gap="medium" align="center">
          <MenuItemText>{children}</MenuItemText>
          <BadgeNext variant="blue" text="BETA" type="strong" />
        </Box>
      ) : (
        <MenuItemText>{children}</MenuItemText>
      )}
    </DropdownMenuItem>
  );
};

export default MenuItemDropdown;
